import validate from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import outside_45referral_45tracking_45global from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/middleware/outsideReferralTracking.global.js";
import manifest_45route_45rule from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  outside_45referral_45tracking_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}